import { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import {
  getExpenseCategory,
  getExpenses,
} from "../../../ApiService/ApiService";
import ExpenseTable from "./ExpenseTable";
import AddExpense from "./AddExpense";
import { Add } from "@mui/icons-material";
function ExpenseSection() {
  const [expenses, setExpenses] = useState({});
  const [showAddExpense, setShowAddExpense] = useState(false);
  const [expenseCategory, setExpenseCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const schoolId = parseInt(sessionStorage.getItem("schoolId"));

  const fetchExpenseCategory = async () => {
    try {
      setLoading(true);
      const response = await getExpenseCategory(schoolId);
      setExpenseCategory(response?.data?.data);
    } catch (err) {
      console.error("Error fetching expenses category:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchExpenses = async () => {
    try {
      setLoading(true);
      const response = await getExpenses(schoolId);
      setExpenses(response?.data);
    } catch (err) {
      console.error("Error fetching expenses:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExpenses();
    fetchExpenseCategory();
  }, [schoolId]);

  const renderMainContent = () => {
    if (showAddExpense) {
      return (
        <AddExpense
          fetchExpenses={fetchExpenses}
          setShowAddExpense={setShowAddExpense}
          expenseCategory={expenseCategory}
        />
      );
    } else {
      return (
        <ExpenseTable
          expenses={expenses}
          fetchExpenses={fetchExpenses}
          expenseCategory={expenseCategory}
        />
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddExpense ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{
            fontWeight: 600,
            fontSize: 22,
            fontFamily: "Barlow, sans-serif",
          }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Expenses
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddExpense(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Add Expense
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default ExpenseSection;
